import { createFileRoute } from "@tanstack/react-router"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { Plans } from "modules/subscription/components/Plans"
import { z } from "zod"

const SearchSchema = z.object({
  checkout: z.enum(["success", "cancel"]).optional(),
})

export const Route = createFileRoute("/_base/_auth/settings/subscription/plans")({
  component: RouteComponent,
  validateSearch: SearchSchema,
})

function RouteComponent() {
  const trackEvent = useTrackEvent()
  const { checkout } = Route.useSearch()

  if (checkout && checkout === "success") {
    trackEvent(TRACKING_EVENTS.CHECKOUT_COMPLETED)
  }

  return <Plans checkout={checkout} />
}
